import { Button, FileField, FileInput, useNotify, useRefresh } from "react-admin";
import PublishIcon from "@mui/icons-material/Publish";
import { Box, Typography } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { customFile } from "features/customFile";
import { activityRequests } from "api/activityApi";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import FormModal from "server/components/Modals/FormModal";

const ImportResultsDialog = ({ foreignLanguageId }) => {
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async values => {
    const file = values?.testResults?.rawFile;

    if (!file) {
      notify("Моля, изберете файл", { type: "warning" });
      return false;
    }
    try {
      await customFile(
        activityRequests.importEntryTestResults(foreignLanguageId),
        { File: file, name: "File" },
        "PATCH",
      );
      refresh();
      notify("Файлът е качен успешно", { type: "success" });
    } catch (err) {
      // Open the per-row conflict details (if any), then let FormModal notify and stay open.
      handleConflictError(err);
      throw err;
    }
  };

  return (
    <>
      <FormModal
        triggerButton={
          <Button
            startIcon={<PublishIcon />}
            sx={{ px: 2 }}
            label="Добави резултати"
          />
        }
        titleContent="Добави резултати от Входящ тест"
        onConfirm={handleSubmit}
      >
        <FileInput
          placeholder={
            <Box sx={{ display: "flex", justifyContent: "center", gap: 2, py: 0.5 }}>
              <UploadFileIcon color="primary" />
              <Typography>Добавете файл</Typography>
            </Box>
          }
          label="Документ"
          source="testResults"
        >
          <FileField
            source="title"
            title="title"
          />
        </FileInput>
      </FormModal>
      <ConflictErrorDialog />
    </>
  );
};

export default ImportResultsDialog;
